import { splitOthersForDisplay } from "./splitOthersForDisplay"

// How many laboratories split that will be displayed in the donut before beeing grouped
export const DEFAULT_TOTAL_SPLITS_DISPLAY = 5
export const OTHERS_GROUP_KEY = "others-group"
// How many laboratories that will be displayed in tooltip before beeing grouped
export const DEFAULT_MAX_OTHERS_IN_TOOLTIP = 10

export const buildMarketShareDonutSplits = <TItem, TSplit>({
  items,
  totalDisplay = DEFAULT_TOTAL_SPLITS_DISPLAY,
  isEligible,
  isFeatured,
  sortItem,
  mapToSplit,
  buildOthersSplit,
  maxOthersInTooltip = DEFAULT_MAX_OTHERS_IN_TOOLTIP,
}: {
  items: TItem[]
  totalDisplay?: number
  isEligible: (item: TItem) => boolean
  isFeatured: (item: TItem) => boolean
  sortItem: (a: TItem, b: TItem) => number
  mapToSplit: (item: TItem) => TSplit
  buildOthersSplit: (rest: TItem[], restToGroup: TItem[]) => TSplit
  maxOthersInTooltip?: number
}): TSplit[] => {
  const eligible = (items || []).filter(isEligible)

  const featured = eligible.filter(isFeatured).sort(sortItem).map(mapToSplit)

  const others = eligible.filter((item) => !isFeatured(item))

  return [
    ...featured,
    ...splitOthersForDisplay({
      others,
      totalDisplay,
      featuredCount: featured.length,
      sortItem,
      mapToSplit,
      buildOthersSplit,
      maxOthersInTooltip,
    }),
  ]
}
